import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterList'
})
export class FilterListPipe implements PipeTransform {

  /**
   * A pipe get data and transform them and show them to users.
   * A pipe to filter the regions by a search term
   * @param items regions like districts or states
   * @param searchText search term
   */
  transform(items: [], searchText?: any): any {
    if (!searchText) {
      return items;
    }
    return items.filter((value: string) =>
      value.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
    );
  }
}
